import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import {Accounts} from "./ScreenAccounts/Accounts";
import {
  ROLE_ADMINISTRATOR,
  ROLE_DIRECTOR,
  ROLE_EMPLOYEE,
} from "../config/constants";
import { Clients } from "./ScreenClients/Clients";
import { Employees } from "./ScreenAccounts/Employees";
import {
  useProfile,
  isProfileRoleTypeTags,
} from "../components/ui";
import {TicketsRouting} from "./modules/ScreenTickets/TicketsRouting";
import { Turnovers } from './ScreenClients/Turnovers';
import { OzonStores } from './ScreenClients/OzonStores';
import { WbStores } from './ScreenClients/WbStores';
import { SupportTickets } from './ScreenClients/Tickets';

export const Routing = () => {
  const { profile } = useProfile();

  return (
    !!profile && (
      <Routes>
        {isProfileRoleTypeTags(profile, [
          ROLE_ADMINISTRATOR,
          ROLE_DIRECTOR,
          ROLE_EMPLOYEE,
        ]) && (
          <>
            <Route path="/employees" element={<Employees />} />
          </>
        )}

        {isProfileRoleTypeTags(profile, [
          ROLE_ADMINISTRATOR,
          ROLE_DIRECTOR,
          ROLE_EMPLOYEE,
        ]) && (
          <>
            <Route path="/clients" element={<Clients />} />
            <Route path="/turnovers" element={<Turnovers />} />
            <Route path="/ozon-stores" element={<OzonStores />} />
            <Route path="/wb-stores" element={<WbStores />} />
            <Route path="/support-tickets" element={<SupportTickets />} />
          </>
        )}

        {isProfileRoleTypeTags(profile, [
          ROLE_ADMINISTRATOR,
          ROLE_DIRECTOR,
        ]) && (
          <>
            <Route path="/tickets/*" element={<TicketsRouting />} />
          </>
        )}

        {isProfileRoleTypeTags(profile, [ROLE_ADMINISTRATOR]) && (
          <>
            <Route path="/accounts" element={<Accounts />} />
          </>
        )}

        {isProfileRoleTypeTags(profile, [
          ROLE_DIRECTOR,
          ROLE_EMPLOYEE,
        ]) && (
          <Route
            exact
            path="/"
            element={<Navigate to="/tickets" replace />}
          />
        )}

        {isProfileRoleTypeTags(profile, [ROLE_ADMINISTRATOR]) && (
          <Route
            exact
            path="/"
            element={<Navigate to="/accounts" replace />}
          />
        )}

        <Route path="/login" element={<Navigate to="/" />} />
        <Route path="/registration" element={<Navigate to="/" />} />
        <Route path="/restore" element={<Navigate to="/" />} />
      </Routes>
    )
  );
};
